import React from 'react';
import { Link } from 'react-router-dom';
import { fmtDate } from './partnerHome';

const LEGEND = [
  { key: 'paid', label: 'Paid', swatch: 'ph-swatch--paid', filter: null },
  { key: 'due', label: 'Payment due', swatch: 'ph-swatch--due', filter: 'payment' },
  { key: 'free', label: 'Free', swatch: 'ph-swatch--free', filter: null },
];

function monthDay(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return { m: '', d: '' };
  return { m: d.toLocaleDateString(undefined, { month: 'short' }).toUpperCase(), d: d.getDate() };
}

export function PlansCard({ totals, onFilter }) {
  const t = totals || { paid: 0, due: 0, free: 0 };
  const all = t.paid + t.due + t.free;
  const pct = (n) => (all ? `${(n / all) * 100}%` : '0%');
  return (
    <section className="adm__card ph-side" data-testid="partner_plans_card">
      <div className="ph-side__head"><h2 className="ph-side__title">Plans &amp; payments</h2><span className="ph-sub">{`${all} athletes`}</span></div>
      <div className="ph-big">{t.paid}<span className="ph-big__label"> on a paid plan</span></div>
      <div className="ph-stack" aria-hidden="true">
        <span className="ph-stack__seg ph-swatch--paid" style={{ width: pct(t.paid) }} />
        <span className="ph-stack__seg ph-swatch--due" style={{ width: pct(t.due) }} />
        <span className="ph-stack__seg ph-swatch--free" style={{ width: pct(t.free) }} />
      </div>
      {LEGEND.map((l) => {
        const inner = (<><span className={`ph-swatch ${l.swatch}`} /><span className="ph-legend__label">{l.label}</span><span className="ph-legend__count">{t[l.key]}</span></>);
        return l.filter
          ? <button key={l.key} type="button" className="ph-legend" onClick={() => onFilter(l.filter)}>{inner}</button>
          : <div key={l.key} className="ph-legend ph-legend--static">{inner}</div>;
      })}
      <p className="ph-foot">Counts only.</p>
    </section>
  );
}

export function ListsCard({ lists }) {
  return (
    <section className="adm__card ph-side" data-testid="partner_lists_card">
      <div className="ph-side__head"><h2 className="ph-side__title">Lists</h2><Link to="/lists" className="ph-link">All</Link></div>
      {lists.length === 0 ? <p className="ph-sub">No lists yet.</p> : lists.slice(0, 5).map((l) => (
        <Link key={l.id} to="/lists" className="ph-listrow">
          <span className="ph-listrow__title">{l.title}</span><span className="ph-listrow__count">{l.athlete_count}</span>
        </Link>
      ))}
    </section>
  );
}

export function EventsCard({ events }) {
  return (
    <section className="adm__card ph-side" data-testid="partner_events_card">
      <div className="ph-side__head"><h2 className="ph-side__title">Coming up</h2></div>
      {events.length === 0 ? <p className="ph-sub">Nothing scheduled.</p> : events.map((e) => {
        const md = monthDay(e.date);
        return (
          <Link key={`${e.type}-${e.id}`} to={e.type === 'camp' ? `/camps?camp=${e.id}` : '/webinars'} className="ph-event">
            <span className="ph-event__date"><span className="ph-event__m">{md.m}</span><span className="ph-event__d">{md.d}</span></span>
            <span><span className="ph-event__name">{e.name}</span><span className="ph-sub ph-event__type">{e.type === 'camp' ? 'Camp' : 'Webinar'} · {fmtDate(e.date)}</span></span>
          </Link>
        );
      })}
    </section>
  );
}
